import { Controller } from "@hotwired/stimulus"

// Turns a streamed payload node into an OS notification, then removes itself.
//
// No popup for the thread you are looking at: the comment (or assignment, or
// reply) already appeared in the timeline in front of you, and a notification
// about it is the computer telling you what you can already see. Hidden tabs
// still notify — you are not looking at that thread.
export default class extends Controller {
  static values = {
    title: String,
    body: String,
    path: String,
    conversationId: String
  }

  connect() {
    this.markHandled()

    if (this.suppressed()) {
      this.element.remove()
      return
    }

    if (!("Notification" in window) || Notification.permission !== "granted") {
      this.element.remove()
      return
    }

    const notification = new Notification(this.titleValue, {
      body: this.bodyValue,
      icon: "/icon.png",
      data: { path: this.pathValue }
    })

    notification.onclick = () => {
      window.focus()
      window.Turbo.visit(this.pathValue)
      notification.close()
    }

    this.element.remove()
  }

  markHandled() {
    const container = this.element.parentElement
    if (container) container.dataset.lastConversationId = this.conversationIdValue
  }

  suppressed() {
    if (document.visibilityState !== "visible") return false

    return this.openConversationId() === this.conversationIdValue
  }

  openConversationId() {
    const fromQuery = new URLSearchParams(window.location.search).get("open")
    if (fromQuery) return fromQuery

    const match = window.location.pathname.match(/^\/conversations\/(\d+)/)
    return match ? match[1] : null
  }
}
